import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showEdmontonData: false,
};

const userPreferencesSlice = createSlice({
  name: "userPreferences",
  initialState,
  reducers: {
    setShowEdmontonData: (state, action) => {
      state.showEdmontonData = action.payload;
    },
  },
});

export const { setShowEdmontonData } = userPreferencesSlice.actions;
export default userPreferencesSlice.reducer; 